/*
 * Copyright (C) 2024 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { takeUntil } from 'rxjs';
import { MediaUploadData } from '../../models';
import { FileUploadService, RESOURCES_FILE_UPLOAD_DATA_SERVICE } from '../../services/file-upload/file-upload.service';

@Component({
  selector: 'ptl-progress-bar-upload',
  templateUrl: './progress-bar-upload.component.html',
  styleUrls: ['./progress-bar-upload.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class ProgressBarUploadComponent implements OnInit, OnDestroy {
  @Input() content: MediaUploadData;
  @Input() fileName: string;
  @Output() contentUploadProgressEmitter: EventEmitter<number> = new EventEmitter<number>();

  uploadProgress: number;

  private subscriptionEnd$: EventEmitter<void> = new EventEmitter<void>();

  constructor(
    @Inject(RESOURCES_FILE_UPLOAD_DATA_SERVICE) private fileUploadService: FileUploadService,
    private cdr: ChangeDetectorRef,
  ) {
    console.log('this.content', this.content);
    console.log('this.fileUploadService.castUploadProgress', this.fileUploadService.castUploadProgress);
    this.fileUploadService.castUploadProgress.pipe(takeUntil(this.subscriptionEnd$)).subscribe((uploadedFiles) => {
      console.log('castUploadProgress uploadedFiles', uploadedFiles);
      console.log('castUploadProgress this.content?.uuid4', this.content?.uuid4);
      console.log('castUploadProgress this.content?.uid', this.content?.uid);
      console.log('castUploadProgress this.fileName', this.fileName);
      const currentFile = uploadedFiles.find(
        (uploadedFile) => uploadedFile.uuid4 === (this.content?.uuid4 || this.content?.uid || this.fileName),
      );
      console.log('currentFile', currentFile);
      if (currentFile) {
        this.uploadProgress = currentFile.uploadedProgress;
        this.contentUploadProgressEmitter.emit(this.uploadProgress);
        this.cdr.detectChanges();
      }
    });
  }

  ngOnInit(): void {
    if (this.content) {
      this.fileName = this.getFileNameFromString(this.content?.fileName) || this.getFileNameFromString(this.content?.realName);
    }
  }

  ngOnDestroy(): void {
    this.subscriptionEnd$.emit();
    this.subscriptionEnd$.complete();
  }

  private getFileNameFromString(filename: string): string | null {
    if (filename && !filename.startsWith('http')) {
      return filename;
    } else {
      return null;
    }
  }
}
